import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { TreePine } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back!");
      navigate(user.role === "admin" ? "/admin" : user.role === "partner" ? "/apukaa-inventory" : "/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 py-16 bg-secondary">
      <div className="w-full max-w-md bg-card border border-border rounded-lg p-8 shadow-sm" data-testid="login-page">
        <div className="flex items-center gap-2 mb-2 text-primary">
          <TreePine className="h-6 w-6 text-accent" strokeWidth={1.5} />
          <span className="font-heading text-2xl font-semibold">LAVista Stays<span className="text-accent">.com</span></span>
        </div>
        <h1 className="font-heading text-3xl font-light mt-4">Welcome back</h1>
        <p className="text-muted-foreground text-sm mt-1">Log in to your client portal.</p>

        <form onSubmit={submit} className="space-y-5 mt-7">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
          <Button type="submit" data-testid="login-submit-btn" disabled={loading} className="w-full rounded-full h-11">
            {loading ? "Logging in..." : "Log in"}
          </Button>
        </form>

        <p className="text-sm text-muted-foreground mt-6 text-center">
          New here?{" "}
          <Link to="/register" data-testid="login-to-register-link" className="text-accent font-semibold hover:underline">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
